<template>
  <!-- 老師列表頁 -->
  <div class="scrollable-container">
    <teachers-toolbar @toggleFilter="toggleFilter" />

    <div class="teacher-list-container">
      <teachers-filter ref="teacherFilter" @query="queryTeachers" />
      <app-overlay-loading :loading="loading" />

      <ul class="teacher-list">
        <li
          v-for="(t) in teachers"
          :class="{'list-item--selected': selectedTeacher === t.id}"
          :key="t.id"
          @click="showProfile(t.id)">
          <teachers-item
            :teacher="t"
            @click="selectedTeacher = t"/>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import {mapActions} from 'vuex';
import {mapGetters} from 'vuex';
import TeachersToolbar from './TeachersToolbar';
import TeachersItem from './TeachersItem';
import TeachersFilter from './TeachersFilter';

export default {
  components: {
    'teachers-toolbar': TeachersToolbar,
    'teachers-filter': TeachersFilter,
    'teachers-item': TeachersItem
  },

  data() {
    return {
      loading: false
    };
  },

  computed: {
    ...mapGetters('teacher', {
      teachers: 'teachers'
    }),

    selectedTeacher: {
      get() {
        return this.$store.state.teacher.selectedTeacher;
      },
      set(value) {
        if (value === this.selectedTeacher) {
          return;
        }
        this.$store.commit('teacher/updateSelectedTeacher', value);
      }
    }
  },

  mounted() {
    this.getTeachers();
  },

  methods: {
    ...mapActions('teacher', {
      getTeachers: 'getTeachers'
    }),

    toggleFilter() {
      this.$refs.teacherFilter.toggle();
    },

    showProfile(id) {
      this.selectedTeacher = id;
      this.changeRightPage('teacher-profile');
    },

    async queryTeachers() {
      this.loading = true;
      try {
        await this.getTeachers();
      } catch (e) {
        // TODO show error
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>

<style lang="stylus" scoped>

.teacher-list-container {
  position: relative
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  overflow-y: hidden;
}

.teacher-list {
  overflow-y: auto;
  padding-left: 0;
  background-color: white;
  width: 100%;
}
</style>
